const packageJson = import('../package.json');

export default {
  appVersion: packageJson.version,
};
